module.exports = __webpack_public_path__ + "img/solo-telephone.629ebae2.svg";